import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { CreateTemporaryQuoteModalLineFragmentDoc } from './CreateTemporaryQuoteModalLine.generated'
import { CreateTemporaryQuoteModalProductFragmentDoc } from './CreateTemporaryQuoteModalProduct.generated'
import { ProductItemProductFragmentDoc } from './ProductItemProduct.generated'
import { QuotesModalListsPricesFragmentDoc } from './QuotesModalListsPrices.generated'
import * as Types from './purchasePlus_graphql'

export const QuotesModalLineFragmentDoc = gql`
  fragment QuotesModalLine on RequisitionLine {
    id
    quantity
    unitPrice
    taxPercentage
    preferredSupplier
    supplierProductCode
    cataloguedProduct {
      id
    }
    supplier {
      id
      name
      supplierRelationship {
        id
      }
    }
    product {
      id
      image
      ...ProductItemProduct
      ...CreateTemporaryQuoteModalProduct
    }
    availableQuotes {
      ...QuotesModalListsPrices
      supplier {
        id
      }
    }
    ...CreateTemporaryQuoteModalLine
  }
  ${ProductItemProductFragmentDoc}
  ${CreateTemporaryQuoteModalProductFragmentDoc}
  ${QuotesModalListsPricesFragmentDoc}
  ${CreateTemporaryQuoteModalLineFragmentDoc}
` as unknown as DocumentNode<Types.QuotesModalLineFragment, unknown>
